export default __webpack_public_path__ + "static/media/AI.e97be618.svg";